import styled from "styled-components";

export default styled.div`
  .profile-background-image {
    position: relative;

    & > img {
      width: 100%;
      height: 10rem;
      object-fit: cover;
      object-position: center;
    }
  }

  .search-profile-page {
    margin-bottom: 2rem;

    .search-profile-header {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      gap: 2rem;

      .profile-picture {
        width: fit-content;

        transform-origin: bottom;
        transform: scale(1.5) translateY(-0%);
        border-radius: 100%;
        box-shadow: rgba(50, 50, 93, 0.2) 0px 30px 60px -12px,
          rgba(0, 0, 0, 0.2) 0px 18px 36px -18px;
      }

      .search-profile-container {
        flex: 1;
        display: flex;
        align-items: center;

        .search-profile-content {
          padding: 1rem;
          flex: 1;
          display: flex;
          flex-flow: column nowrap;
          gap: 0.5rem;
          justify-content: center;

          .user-card-uni {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 0.3rem;
            opacity: 0.6;
          }
        }
        .search-profile-actions {
        }
      }
    }
  }

  .search-profile-main-info {
    .search-profile-main-info-container {
      display: flex;
      flex-flow: column;
      gap: 3rem;

      .search-profile-pill-cont {
        display: flex;
        gap: 2rem;

        .item-cont {
          .pill-cont {
            margin-top: 0.2rem;
            display: flex;
            gap: 0.4rem;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .profile-background-image {
      & > img {
        height: 7rem;
      }
    }

    .search-profile-page {
      margin-bottom: 0rem;

      .search-profile-header {
        align-items: center;
        justify-content: center;
        gap: 0;
        /* margin-top: 1rem; */
        margin-bottom: 1rem;
        gap: 0px;

        .profile-picture {
          display: flex;
          transform: scale(0.8) translateY(-10%);
          /* position: absolute; */
          /* top: 120px; */
        }

        .search-profile-container {
          flex: auto;
          justify-content: flex-start;

          .search-profile-content {
            width: 100%;
            padding-left: 0;

            .user-card-uni {
            }
          }
          .search-profile-actions {
            position: absolute;
            top: 10px;
            right: 10px;
          }
        }
      }
    }

    .search-profile-main-info {
      .search-profile-main-info-container {
        .search-profile-pill-cont {
          flex-flow: column nowrap;
          gap: 1rem;

          .item-cont {
            .pill-cont {
              flex-wrap: wrap;
            }
          }
        }
      }

      .search-profile-files {
        .MuiImageList-standard {
          grid-template-columns: repeat(1, 1fr) !important;
        }
      }
    }
  }
`;
